/* eslint-disable import/prefer-default-export */
import { InsightData } from 'schemas/action/InsightDataSchema'
import { SocialWebDomainsWidget } from 'schemas/SocialWebDomainsWidgetSchema'
import { DashboardWidget } from '../../../../features/widget/types'
import { InsightCount } from '../../../../schemas/action/InsightCountSchema'
import { InsightViewOptionStrings } from '../../../../enums/InsightViewOption'
import Source from '../../../../enums/Source'
import { CountTypeStrings } from '../../../../enums/CountType'

const applyTopN = (
  widgetData: DashboardWidget<InsightCount>,
  widgetSetting: SocialWebDomainsWidget
): InsightData[] =>
  widgetData.data[0].results![0].data.insights![0].dataset!.flatMap((result) =>
    result.set!.slice(0, widgetSetting.topN)
  )

export const convertToBarData = (
  widgetData: DashboardWidget<InsightCount>,
  widgetSetting: SocialWebDomainsWidget
) => [
  {
    data: applyTopN(widgetData, widgetSetting).map((item) => item.value as number)
  }
]

export const getInsightDataNames = (
  widgetData: DashboardWidget<InsightCount>,
  widgetSetting: SocialWebDomainsWidget
) => applyTopN(widgetData, widgetSetting).map((item) => item.name as string)

export const getSourceByInsightViewOption = (insightViewOption: InsightViewOptionStrings) => {
  switch (insightViewOption) {
    case 'BLOGS':
      return Source.BLOGS
    case 'FORUMS':
      return Source.FORUMS
    case 'NEWS':
      return Source.NEWS
    default:
      return undefined
  }
}

export const getThemeColorByCountType = (countType: CountTypeStrings) => {
  switch (countType) {
    case 'MENTIONS':
      return 'metric.mainMetrics.mentions'
    case 'POSTS':
      return 'metric.mainMetrics.post'
    default:
      return ''
  }
}

export const getInsightDataByName = (
  widgetData: DashboardWidget<InsightCount>,
  widgetSetting: SocialWebDomainsWidget,
  name: string
) => applyTopN(widgetData, widgetSetting).find((insightData) => insightData.name === name)
